<div class="modal">
  <div class="modal__header">
    <ng-content select="[header-icon]"></ng-content>
    <h1 class="modal__title">
      <ng-content select="[header-title]"></ng-content>
    </h1>
    <span class="modal__description">
      <ng-content select="[header-description]"></ng-content>
    </span>
    <img ngSrc="images/header-logo.svg" class="modal__logo" alt="" width="267" height="267" />
  </div>
  <mat-dialog-content class="modal__body" [class.modal__body--with-actions]="actionsType() !== 'none'">
    <ng-content select="[body]"></ng-content>
  </mat-dialog-content>
  @if (actionsType() === 'normal') {
    <mat-dialog-actions class="modal__actions">
      <ng-content select="[actions]"></ng-content>
    </mat-dialog-actions>
  }
  @if (actionsType() === 'space-between') {
    <mat-dialog-actions class="modal__actions modal__actions--space-between">
      <ng-content select="[actions-space-between]"></ng-content>
    </mat-dialog-actions>
  }
  @if (hasFooter()) {
    <div class="modal__footer">
      <ng-content select="[footer-actions]"></ng-content>
    </div>
  }
</div>
